export default __webpack_public_path__ + "static/media/balls.1ca5e054.png";